import { removeAuthUserData, setAuthUserData } from "../../localStorage";
import { setUser, clearUser, setError } from "./authSlice";

export const loginUser = (user) => async (dispatch) => {
  try {
    setAuthUserData(user);
    dispatch(setUser(user));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    removeAuthUserData();
    dispatch(clearUser());
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const updateUserProfile =
  (profileData) => async (dispatch, getState) => {
    try {
      const { user } = getState().auth;
      const updatedUser = { ...user, ...profileData };
      setAuthUserData(updatedUser);
      dispatch(setUser(updatedUser));
    } catch (error) {
      dispatch(setError(error.message));
    }
  };
